import { PlatformApi } from '~/services/api/platform'

export class DogService extends PlatformApi {
  async getAll() {
    return await this.get('/dog')
  }

  async getByUserId(userId) {
    return await this.get(`/dog/user/${userId}`)
  }

  async create() {
    return await this.post('/dog')
  }

  async update(dogId) {
    return await this.put(`/dog/${dogId}`)
  }

  async deleteDog(dogId) {
    return await this.delete(`/dog/${dogId}`)
  }
}
